<template lang="pug">
div(v-if="ot.estado.estado.nombre !== 'Acreditación'")
  button.change-button(
    :disabled="disabled || loading"
    @click="openModal"
    @hide="hideModal()"
  ) {{changeNameButton()}}
    b-spinner(v-if="loading" class="ml-2" variant="white" small)

  SamtekModal(
    v-model="show"
    title="Información de partes solicitadas"
    size="xl"
    dialog-class="parts-modal-dialog"
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    confirmText="Guardar"
    cancelText="Cancelar"
    :loading="loading"
    @shown="onModalShown"
    @hide="onModalHide"
    @confirm="solicitarPartes"
    @cancel="cancelarModal"
  )
    div(v-if="ot.solicitud_partes && ot.solicitud_partes.length < 1")
      span(v-if="parts.length < 1") No existe solicitud de partes
    div(v-else)
      PartsTable(:ot="ot" :showStateActionColumn="true" @changed="$emit('changed')")

    b-form( @submit.stop.prevent="solicitarPartes()" )
      b-table(
        :fields="tableFields"
        :items="parts"
        responsive
        style="overflow: visible !important"
      )
        template( #cell(index)="{ index }" )
          span.number.circle.bg-button {{ index + 1 }}

        //- TODO: cambiar por vue-typeahead-bootstrap y arreglar código
        template( #cell(partNumber)="{ index, item: part }" )
          b-form-group
            SILLAutocomplete(
              @click.native="onclick(index)"
              :search="searchParts"
              displayAttribute="part_number"
              placeholder="Ej: AF3FC3F"
              :onSubmit="onPartSelected"
              :searching="searching"
               width="200px"
              @keyup.native="setPartNumber(index)"
              v-bind:key="index"
              :class="getAutoCompleteClass(index)"
              :disabled="part.parte.id !== null"
            )
            b-form-invalid-feedback(
              :state="validateState(`$each.$iter[${index}].parte.partNumber`)"
            ) 
              span(v-if="!$v.parts.$each.$iter[index].parte.partNumber.required") Campo requerido
              span(v-else-if="!$v.parts.$each.$iter[index].parte.partNumber.partSelected") Debe seleccionar un elemento de la lista
        template( #cell(codigo)="{ item: part }" )
          VueBarcode(
            v-model="part.parte.partNumber"
            width=1 height=30 textAlign="center" fontSize="13")

        template( #cell(description)="{ index, item: part }" )
          b-form-group
            b-form-input(
              v-if="$v.parts.$each.$iter[index]"
              v-model="$v.parts.$each.$iter[index].parte.description.$model"
              :state="validateState(`$each.$iter[${index}].parte.description`)"
              :disabled="$v.parts.$each.$iter[index].parte.partNumber.$model"
              :formatter="formatter"
              style="text-transform:uppercase;"
            )
            b-form-invalid-feedback Campo requerido

        template( #cell(allocated)="{ index }" )
          b-form-group
            b-radio-group.d-flex(
              v-if="$v.parts.$each.$iter[index]"
              v-model="$v.parts.$each.$iter[index].allocated.$model"
              :state="validateState(`$each.$iter[${index}].allocated`)"
              :options="[{ text: 'Sí', value: true }, { text: 'No', value: false }]"
            )
            b-form-invalid-feedback(
              :state="validateState(`$each.$iter[${index}].allocated`)"
            ) Campo requerido

        template( #cell(realLocation)="{ item: part }" )
          b-form-input(v-model="part.parte.realLocation")

        template( #cell(closeButton)="{ item }" )
          b-button(@click="quitarPartePorId(item.id_local)" variant="danger").circle x


    button(@click="agregarParte" v-if="parts.length < 50").ask-parts.mt-2 + Agregar repuesto
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { get as _get } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import VueBarcode from 'vue-barcode'
import SILLAutocomplete from '@/components/UI/SILLAutocomplete.vue'
import PartsTable from '../../AskParts/PartsTable.vue'
import AskPartsForm from '../../AskParts/AskPartsForm.vue'
import print from '../../../utils/print'

const partSelected = (value, vm) => {
  // Si no hay partNumber, no validar esto (Lo hace el required)
  if (!value) return true
  return vm.id !== null
}

export default {
  name: 'ActionSolicitarPartes',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  components: {
    PartsTable,
    AskPartsForm,
    SILLAutocomplete,
    VueBarcode,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  async created() {
    await this.getAllUsers()
  },
  data() {
    return {
      show: false,
      parts: [],
      partsOriginales: [], // <--- copia de respaldo
      limpiarAlCerrar: true,
      searching: false,
      selectedPart: null,
      partNumberInputText: null,
      ot_data: null,
      tableFields: [
        { key: 'index', label: '#' },
        { key: 'partNumber', label: 'Part Number' },
        { key: 'codigo', label: 'Código' },
        { key: 'description', label: 'Descripción' },
        { key: 'allocated', label: 'Allocated' },
        { key: 'realLocation', label: 'Real Location' },
        { key: 'closeButton', label: '' },
      ],
    }
  },
  validations: {
    parts: {
      $each: {
        allocated: { required },
        parte: {
          partNumber: { required, partSelected },
          description: { required },
        },
      },
    },
  },
  computed: {
    ...mapGetters('Warehouse', ['allUsers']),
    ...mapGetters('AuthenticationStore', ['user']),
  },
  methods: {
    ...mapActions('Diagnosticos', ['askParts', 'searchByPartNumber']),
    ...mapActions('Warehouse', ['getAllUsers']),
    ...mapActions('Notifications', ['sendNotification']),
    ...mapActions('OTStore', ['getOT']),
    ...mapActions('Warehouse', ['changeWarehouseState']),
    formatter(value) {
      if (!value || !value.length) return null
      return value.toUpperCase().substr(0, 10)
    },
    hideModal() {
      this.show = false
      this.$v.parts.$reset()
      if (this.limpiarAlCerrar) {
        this.parts = []
      }
    },
    cancelarModal() {
      this.limpiarAlCerrar = false
      this.parts = JSON.parse(JSON.stringify(this.partsOriginales)) // restaurar lista original
      this.show = false
      this.$nextTick(() => {
        this.limpiarAlCerrar = true
      })
    },
    impresionPartes(ot) {
      // método para probar la impresión
      const now = moment().format('DD/MM/YYYY H:mm:ss')
      print(
        this.ot.ot,
        this.parts.filter((part) => part.allocated),
        ot || this.ot,
        now
      )
    },
    agregarParte() {
      this.parts.push({
        id_local: Date.now() + Math.random(),
        ot: this.ot.ot,
        parte: {
          id: null,
          partNumber: null,
          description: null,
          realLocation: null,
        },
        allocated: null,
        newPartToSearch: true,
      })
    },
    openModal() {
      this.startLoading()
      this.show = true
      this.cargarPartesAprobadas()
    },
    onModalShown() {
      // Modal completamente abierto, detener loading de apertura
      this.stopLoading()
    },
    onModalHide() {
      // Asegurar que el loading se detenga al cerrar
      this.stopLoading()
    },
    cargarPartesAprobadas() {
      this.partsOriginales = []

      this.ot.solicitud_cotizacion_interna.forEach((ci) => {
        ci.partes_solicitadas.forEach((ps) => {
          const parte = {
            id_local: Date.now() + Math.random(), // identificador único
            ot: this.ot.ot,
            parte: {
              id: ps.id,
              partNumber: ps.part_number,
              description: ps.description,
              realLocation: ps.real_location,
            },
            allocated: true,
            newPartToSearch: false,
          }
          this.partsOriginales.push(parte)
        })
      })

      // clonamos la lista original a parts
      this.parts = JSON.parse(JSON.stringify(this.partsOriginales))
    },
    async solicitarPartes() {
      this.$v.parts.$touch()
      if (this.$v.parts.$anyError) {
        return
      }

      try {
        await this.executeWithLoading(async () => {
          const parts = this.parts.filter((p) => p.newPartToSearch)
          const resp = await this.askParts({ otId: this.ot.ot, parts })

          if (resp && (resp.status === 201 || resp.status === 200)) {
            this.$bvToast.toast(`${resp.data}`, {
              variant: 'success',
            })
            this.show = false
            try {
              const otActualizada = await this.getOT(this.ot.ot)
              // función para impresión de código de partes solicitadas
              if (this.parts.filter((part) => part.allocated).length > 0) {
                this.impresionPartes(otActualizada)
              }
            } catch (error) {
              console.error('No se pudo refrescar la OT para imprimir:', error)
            } finally {
              this.$emit('changed')
              this.hideModal()
            }
          }
        })
      } catch (error) {
        console.error('Error al solicitar partes:', error)
        this.$bvToast.toast('Error al solicitar partes', {
          variant: 'danger',
        })
      }
    },
    async searchParts(partNumber) {
      this.partNumberInputText = partNumber
      if (partNumber.length <= 2) {
        return []
      }
      this.searching = true
      const resp = await this.searchByPartNumber({
        partNumber,
        shortQuery: true,
      })
      this.searching = false
      let partes = resp.data.results
      if (resp.data.results.length === 0) {
        partes = []
      }
      return partes
    },
    quitarParte() {
      // index
      // this.parts.splice(index, 1)
      this.parts.push({
        id_local: Date.now() + Math.random(), // Asegura unicidad
        ot: this.ot.ot,
        parte: {
          id: null,
          partNumber: null,
          description: null,
          realLocation: null,
        },
        allocated: null,
        newPartToSearch: true,
      })
    },
    quitarPartePorId(idLocal) {
      this.parts = this.parts.filter((p) => p.id_local !== idLocal)
    },
    onPartSelected(selectedItem) {
      this.selectedPart = selectedItem
    },
    setPartNumber(index) {
      this.parts[index].parte.partNumber = this.partNumberInputText
      this.$v.parts.$each.$iter[index].parte.partNumber.$model =
        this.partNumberInputText
    },
    onclick(index) {
      if (this.selectedPart) {
        this.parts[index].parte.id = this.selectedPart.id
        this.parts[index].parte.description = this.selectedPart.description
        this.parts[index].parte.partNumber = this.selectedPart.part_number
        this.parts[index].parte.realLocation = this.selectedPart.real_location
        // Forzar re-render del componente para aplicar el disabled
        this.$forceUpdate()
      }
      this.selectedPart = null
    },
    changeNameButton() {
      const partes =
        this.ot.solicitud_partes?.filter(
          (parte) =>
            parte.estado !== 'Dropped' &&
            parte.estado !== 'Usado' &&
            parte.estado !== 'Part failed'
        ) || []
      return partes.length > 0 ? 'Cerrar o pedir repuestos' : 'Pedir repuestos'
    },
    validateState(fieldPath) {
      const field = _get(this.$v.parts, fieldPath)
      if (!field) return null
      const { $dirty, $error } = field
      return $dirty ? !$error : null
    },
    getAutoCompleteClass(index) {
      const state = this.validateState(`$each.$iter[${index}].parte.partNumber`)
      return state
        ? 'autocomplete-valid'
        : state === false
        ? 'autocomplete-invalid'
        : ''
    },
  },
}
</script>

<style lang="scss">
.parts-modal-dialog {
  max-width: 90% !important;

  @media (min-width: 1600px) {
    max-width: 80% !important;
  }
}
</style>

<style lang="scss" scoped>
.form-control {
  border: 1px solid #cbcbcb;
  opacity: 1;
}

.col-1 {
  flex: 0 0 5.333333%;
  max-width: 5.333333%;
}

.number {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  opacity: 1;
  border-radius: 50%;
}

.parts-card {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  opacity: 1;
  height: 85vh;
}

.part-card {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  opacity: 1;
}

label {
  font-weight: bold;
}

.label {
  letter-spacing: 0px;
  color: #74788d;
  opacity: 1;
}

.part-number {
  color: #253590;
}

.title {
  letter-spacing: 0px;
  color: #74788d;
  opacity: 1;
  font-weight: 600;
}

.ask-parts {
  color: #fff;
  background-color: #5b73e8;
  border-color: #5b73e8;
  width: 175px;
  height: 45px;
  border-radius: 5px;
  font-weight: 600;
}
</style>
